module.exports = __webpack_public_path__ + "img/coldway-awards-en.ffa9337b.png";